import { render } from "./ProductColorOption.vue?vue&type=template&id=45bf5a34&scoped=true&ts=true"
import script from "./ProductColorOption.vue?vue&type=script&lang=ts"
export * from "./ProductColorOption.vue?vue&type=script&lang=ts"

import "./ProductColorOption.vue?vue&type=style&index=0&id=45bf5a34&scoped=true&lang=css"

import exportComponent from "/Users/angeloquijano/Git/IWARI/iwari-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45bf5a34"]])

export default __exports__